import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { UserGroup } from '../../model/user-group';
import { DataService } from './../../../core/service/base/data.service';
import { MessageService } from './../../../core/service/message.service';
import { ProgressBarService } from './../../../core/service/progress-bar.service';
import { finalize, map, Observable } from 'rxjs';

@Injectable()
export class UserGroupService extends DataService<UserGroup> {
  constructor(
    private _client: HttpClient,
    @Inject(APP_CONFIG) private _config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(_client, _config, messageService, UserGroup, progressBar, 'user-group');
  }

  getFeatures(): Observable<{ name: string; features: string[] }[]> {
    return this._client.get<{ name: string; features: string[] }[]>(this.endpoint + '/features');
  }

  getUserGroupsWithFeatures(): Observable<UserGroup[]> {
    this.progressBar.start();
    return this.client.get<UserGroup[]>(`${this.endpoint}/with-features`).pipe(
      map(items => items.map(x => this.createModel(x))),
      finalize(() => this.progressBar.stop())
    );
  }
}
